import React from 'react';
import classnames from 'classnames';
import { IconCheckmarkFill } from '@saucelabs/ds-icons';

export const SelectedDCCheckmark = ({ className, ...props }: SelectedDCCheckmarkProps) => (
  <IconCheckmarkFill
    className={classnames('h-2 w-2 ml-1 fill-current text-blue-700', className)}
    {...props}
  />
);

export interface SelectedDCCheckmarkProps {
  className?: string;
}
